"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatesSelectionFooter = void 0;
var React = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var trapezoid_button_1 = require("./trapezoid-button");
var DatesSelectionFooter = function (_a) {
    var isPickingEndDate = _a.isPickingEndDate, toggleDateChangeVisibility = _a.toggleDateChangeVisibility, onClear = _a.onClear, setFocusedDate = _a.setFocusedDate, dateTo = _a.dateTo, dateFrom = _a.dateFrom;
    var clear = function () {
        setFocusedDate((0, date_fns_1.parseISO)(dateFrom));
        onClear({ date_from: dateFrom, date_to: dateTo });
    };
    var setFocusOnToday = function () {
        setFocusedDate(new Date());
    };
    var close = function (event) {
        event.stopPropagation();
        toggleDateChangeVisibility === null || toggleDateChangeVisibility === void 0 ? void 0 : toggleDateChangeVisibility(false);
    };
    return (React.createElement("div", { className: "date-range-footer d-flex" },
        React.createElement("div", { className: "d-flex align-items-center me-5 cursor-pointer date-range-footer__el", onClick: clear },
            React.createElement("i", { className: "uil-multiply font-size-xl me-2" }),
            React.createElement("span", { className: "font-size-sm" }, "wyczy\u015B\u0107")),
        React.createElement("div", { className: "d-flex align-items-center cursor-pointer date-range-footer__el", onClick: setFocusOnToday },
            React.createElement("i", { className: "uil-check-square font-size-xl me-2" }),
            React.createElement("span", { className: "font-size-sm" }, "poka\u017C dzi\u015B")),
        React.createElement("div", { className: "flex-fill" }),
        React.createElement(trapezoid_button_1.TrapezoidButton, { onClick: close, isDisabled: isPickingEndDate }, "wybieram")));
};
exports.DatesSelectionFooter = DatesSelectionFooter;
